import React, { useState, useContext, useEffect, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { ModalLost, ModalCancel } from '../../components';
import Button from '../Button';
import { useHistory } from 'react-router-dom';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';

function LostCancelButton(props) {
  const [modalLostOpen, setModalLostOpen] = useState(false);
  const [modalCancelationOpen, setmodalCancelationOpen] = useState({ visible: false });
  const [isEndorsement, setIsEndorsement] = useState(false);
  const [shouldRenderAnyButton, setShouldRenderAnyButton] = useState(true);
  const [idProduct, setIdProduct] = useState(null);
  const [operation, setOperation] = useState(null);

  const history = useHistory();

  const authContext = useContext(GlobalAuthContext);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(props.idOperation)
      .then(response => response.json())
      .then(response => {
        setOperation(response);
        if (response.idProductOperation) setIdProduct(response.idProductOperation);
        if (response.idDomain !== 26 && response.idDomain !== 570 && response.idDomain !== 686) setIsEndorsement(true)
        if (response.isBound) setShouldRenderAnyButton(false)
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data: \n" + error);
      });
  }

  useEffect(() => {
    getOperationInfo()
  }, [])

  const renderButton = () => {
    if (shouldRenderAnyButton && isEndorsement) {
      return (
        <Button
          type="button"
          third
          onClick={() => {
            setmodalCancelationOpen({ visible: true })
          }}
        >
          CANCELAR
        </Button>
      )
    }

    if (shouldRenderAnyButton && !isEndorsement) {
      return (
        <Button
          type="button"
          third
          onClick={() => {
            setModalLostOpen(true)
          }}
        >
          {props.title || "PERDIDO"}
        </Button>
      )
    }

    return <div />
  }

  return (
    <>
      <ModalCancel
        idQuestion={props.idQuestion}
        history={history}
        show={modalCancelationOpen.visible}
        setDialog={setmodalCancelationOpen}
        idOperation={props.idOperation}
      />

      <ModalLost
        idProduct={idProduct}
        idQuestion={props.idQuestion}
        idOperation={props.idOperation}
        show={modalLostOpen}
        idDomain={operation?.idDomain}
        setDialog={setModalLostOpen}
        history={history}
      />

      {operation ? renderButton() : <></>}

    </>
  );
}

const propTypes = {
  isEndorsement: PropTypes.bool,
}

LostCancelButton.prototype = propTypes;
export default LostCancelButton;